import {useParams} from 'react-router-dom';

import {stakeColumns, useGetUserStakes} from '@entities/stake';
import {MrTable} from '@shared/components';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';

import {PaginationState} from '@/shared/types';

const localStorageKey = 'userAccountStakesTableV1';

export const StakesTab = () => {
  const {id: userId} = useParams<{id: string}>();
  const {urlState, setUrl} = useUrlState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const {
    data,
    isPending: isLoading,
    error,
  } = useGetUserStakes(
    {
      userId: userId ?? '',
      page: urlState.pageIndex + 1,
      pageSize: urlState.pageSize,
    },
    {enabled: Boolean(userId)},
  );

  return (
    <MrTable
      columns={stakeColumns}
      data={data?.items ?? []}
      error={error}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      enablePagination
      manualPagination
      onPaginationChange={setUrl}
      rowCount={data?.total ?? 0}
      state={{isLoading, pagination: urlState}}
      enableColumnPinning
      initialState={{columnPinning: {left: ['id']}}}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
